import React from 'react';
import styles from './WelcomeNavbar.module.scss';
import synnexLogoWhite from '../../Assets/Images/Synnex-logo-white.svg';
import synnexLogoDark from '../../Assets/Images/synnex-logo-dark.svg';
import ThemeSwitcher from '../../Components/ThemeSwitcher';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

const WelcomeNavbar = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch(e => {
            console.error(e);
        });
    }

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <div className={styles.logo}>
          <img src={synnexLogoWhite} alt="Synnex Logo" className={styles.logoWhite} />
          <img src={synnexLogoDark} alt="Synnex Logo" className={styles.logoDark} />
        </div>
      </div>
      <div className={styles.headerRight}>
        <ThemeSwitcher />
        <button className={styles.loginButton} onClick={handleLogin}>Login</button>
      </div>
    </header>
  );
};

export default WelcomeNavbar;